//
//
//
//
//
//

export default {
  name: 'App',
  mounted() {
    console.log(process.env.NODE_ENV,'production')
    if (process.env.NODE_ENV !== 'production') {
      let script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules%2Fconsole%2Fconsolelog.js');
      document.getElementsByTagName('body')[0].appendChild(script);
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue